var React = require('react');

function IconReact (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"currentColor","r":"2.05","key":0}),React.createElement("ellipse",{"rx":"11","ry":"4.2","fill":"none","stroke":"currentColor","key":1}),React.createElement("ellipse",{"rx":"11","ry":"4.2","transform":"rotate(60)","fill":"none","stroke":"currentColor","key":2}),React.createElement("ellipse",{"rx":"11","ry":"4.2","transform":"rotate(120)","fill":"none","stroke":"currentColor","key":3})]);
}

IconReact.defaultProps = {"viewBox":"-11.5 -10.232 23 20.463"};

module.exports = IconReact;

IconReact.default = IconReact;
